import { Schema } from '../schema.js';
import { BigNumber } from '../types.js';

export class PrimitiveValidator {
  constructor(public readonly schema: Schema) {
  }

  validString(v: any) {
    return typeof v === 'string';
  }

  validMlString(v: any) {
    return this.validString(v) ||
      Object.entries(v).every(([lang, value]) =>
        this.schema.languages.includes(lang) && this.validString(value));
  }

  validNumber(value: any) {
    return typeof value === 'number';
  }

  validBigNumber(value: any) {
    try {
      new BigNumber(value);
    } catch(e) {
      return false;
    }
    return true;
  }

  validBoolean(value: any) {
    return typeof value === 'boolean';
  }
}